import { RiskLevels } from "../../utils/enums";
import { getRiskLevel } from "../../utils/riskUtils";
import { Chip, useTheme } from "@mui/material";

export const RiskScoreChip = ({ score }) => {
  const theme = useTheme();
  const level = getRiskLevel(score);
  let bgColor, textColor;
  if (level === RiskLevels.LOW) {
    bgColor = theme.customColors.status.success.bg;
    textColor = theme.customColors.status.success.text;
  } else if (level === RiskLevels.MEDIUM) {
    bgColor = theme.customColors.status.warning.bg;
    textColor = theme.customColors.status.warning.text;
  } else {
    bgColor = theme.customColors.status.error.bg;
    textColor = theme.customColors.status.error.text;
  }
  return (
    <Chip
      label={`${score} - ${level}`}
      variant="filled"
      size="small"
      sx={{
        minWidth: "90px",
        height: "28px",
        fontWeight: 600,
        fontSize: "0.75rem",
        border: "none",
        borderRadius: 0,
        boxShadow: theme.customColors.shadow.main,
        transition: "all 0.2s ease",
        backgroundColor: bgColor,
        color: textColor,
      }}
    />
  );
};
